import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { DeliveryServiceResource } from "@exonn/js-sdk";

export const module: Module<DeliveryServiceResource> = {
  id: ResourceEnum.DeliveryService,
  bigIcon: <span className={"icon-20-deliv_cost"} />,
  smallIcon: <span className={"icon-15-deliv_cost"} />,
  name: (t: TFunction) => t("moduleName.shipping-cost-rules"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
